import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageNotifyCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M22.6 12.6a1 1 0 1 0-2 0h2m-1.816 3.878-.915-.404a1 1 0 0 0-.075.545zm-4.086 4.495.242-.97a1 1 0 0 0-.732.099zm4.903 1.226-.243.97a1 1 0 0 0 1.233-1.111zM10.386 4.151a1 1 0 0 0-.373-1.965l.186.982zM21.599 12.6h-1a8.6 8.6 0 0 1-.73 3.474l.915.404.914.404c.58-1.31.901-2.76.901-4.282zM12 22.2v-1a8.6 8.6 0 0 1-8.6-8.6h-2c0 5.854 4.746 10.6 10.6 10.6zm4.699-1.227-.49-.871a8.56 8.56 0 0 1-4.209 1.098v2c1.883 0 3.654-.492 5.19-1.355zm4.903 1.226.242-.97-4.902-1.226-.243.97-.242.97 4.902 1.226zm-.817-5.721-.99.141.817 5.721.99-.14.99-.142-.817-5.721zM2.399 12.6h1a8.6 8.6 0 0 1 6.986-8.449l-.186-.983-.186-.982c-4.905.93-8.614 5.238-8.614 10.414zm19.2-7.2h-1A2.6 2.6 0 0 1 18 8v2a4.6 4.6 0 0 0 4.6-4.6zM18 9V8a2.6 2.6 0 0 1-2.6-2.6h-2A4.6 4.6 0 0 0 18 10zm-3.6-3.6h1A2.6 2.6 0 0 1 18 2.8v-2a4.6 4.6 0 0 0-4.6 4.6zM18 1.8v1a2.6 2.6 0 0 1 2.6 2.6h2A4.6 4.6 0 0 0 18 .8z"
    />
  </svg>
);
export default SvgMessageNotifyCircle;
